import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { SharedModule } from "app/_shared/shared.module";
import { WindowModule } from "@progress/kendo-angular-dialog";
import { DossierRoutingModule } from "./dossier-routing.module";
import { DossierListComponent } from "./dossier-list/dossier-list.component";
import { CedFrameLayoutModule } from "ced-ng-library";
import { CaseTypelistComponent } from "./case-type-list/case-type-list.component";
import { DossierGenesysFiltredComponent } from './dossier-genesys-filtred/dossier-genesys-filtred.component';
import { DivFocusoutDirective } from "./dossier-list/div-focusout.directive";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    WindowModule,
    TreeViewModule,    
    DossierRoutingModule,
    CedFrameLayoutModule
  ],
  declarations: [DossierListComponent, CaseTypelistComponent,DossierGenesysFiltredComponent, DivFocusoutDirective],
  entryComponents:[CaseTypelistComponent]
})
export class DossierModule {}